var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:_vm.$style.container},[_c('WishList',{attrs:{"config":{
      serviceUrl: '/rest-services/wishlist/send',
      ftlUrl:
        'http://www-qa.wika.dev.intern.etecture.de/de-de/merkzettel-mail-template.ftl',
      title: 'Merkzettel',
      emailPlaceholder: 'E-Mail',
      buttonText: 'Merkzettel',
      emailErrorMessage: 'Die E-Mail-Adresse hat ein falsches Format.',
      formErrorMessage:
        'Zur Zeit befinden sich keine Dokumente auf Ihrem Merkzettel.',
      technicalErrorMessage: 'Es ist ein technischer Fehler aufgetreten.',
      successMessage: 'Die E-Mail wurde erfolgreich versendet.',
      counterText: 'Dokumente',
      emptyText:
        'Zur Zeit befinden sich keine Dokumente auf Ihrem Merkzettel. Sie können alle Dokumente aus dem Bereich Download zu Ihrem Merkzettel hinzufügen. Wählen Sie hierzu die gewünschte Sprache über das Flaggensymbol.',
      formText:
        'Um Ihren Downloadlink per E-Mail zu erhalten, tragen Sie hier Ihre Adresse ein:',
      type: 'Typ',
      types: 'Typen'
    }}}),_c('div',{class:[_vm.$style.main, 'columns', 'is-multiline', 'is-variable', 'is-5']},[_c('div',{class:[
        _vm.$style.links,
        'column',
        'is-half-tablet',
        'is-one-quarter-desktop'
      ]},[_c('ul',_vm._l((_vm.footerLinksOne),function(link,index){return _c('li',{key:index},[_c('a',{attrs:{"href":link.url,"target":link.newWindow ? '_blank' : '_self'}},[_vm._v("\n            "+_vm._s(link.title)+"\n          ")])])}),0)]),_c('div',{class:[
        _vm.$style.links,
        'column',
        'is-half-tablet',
        'is-one-quarter-desktop'
      ]},[_c('ul',_vm._l((_vm.footerLinksTwo),function(link,index){return _c('li',{key:index},[_c('a',{attrs:{"href":link.url,"target":link.newWindow ? '_blank' : '_self'}},[_vm._v("\n            "+_vm._s(link.title)+"\n          ")])])}),0)]),_c('div',{class:[
        _vm.$style.contact,
        'column',
        'is-half-tablet',
        'is-one-quarter-desktop'
      ]},[_c('div',{class:_vm.$style.title},[_vm._v("Kontakt")]),_c('p',[_vm._v("WIKA Alexander Wiegand SE & Co. KG")]),_vm._m(0),_c('p',[_vm._v("Tel.: +49 9372 132-0")]),_vm._m(1)]),_c('NewsletterQuickSubscription',{attrs:{"config":{
        title: 'WIKA-Newsletterd',
        text: 'Erhalten Sie aktuelle Informationen und Neuigkeiten von WIKA.',
        errorMessage: 'Bitte tragen Sie eine valide E-Mail-Adresse ein.',
        placeholder: 'E-Mail-Adresse',
        newsletterFormUrl: 'newsletter-form.html'
      }}})],1),_c('div',{class:[
      _vm.$style.nav,
      'columns',
      'is-vcentered',
      'is-multiline',
      'is-variable',
      'is-5'
    ]},[_c('div',{class:[_vm.$style.copyright, 'column']},[_c('span',[_vm._v("© 2019 WIKA Alexander Wiegand SE & Co. KG")])]),_c('SocialLinks',{attrs:{"socialLinks":_vm.socialLinks}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Alexander-Wiegand-Str. 30 "),_c('br'),_vm._v("63911 Klingenberg - Deutschland")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("E-Mail: "),_c('a',{attrs:{"href":"mailto:info@wika.de"}},[_vm._v("info@wika.de")])])}]

export { render, staticRenderFns }